import React, { useState } from 'react';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { Text, Preset } from '@lux/text';
import { TitlePreset } from '@lux/title';
import { Color } from '@lux/tokens';
import { Translate } from '@pegasus/translation';

import {
    Container,
    Background,
    Paragraph,
    MoreContent,
    ButtonContainer,
    Title,
    MoreButton,
} from './styles';

export const ShutdownMessage = () => {
    const [isFullMessageShown, setIsFullMessageShown] = useState(false);
    const handleMoreButtonClick = () => {
        setIsFullMessageShown(true);
    };

    return (
        <Background>
            <Container>
                <Title preset={TitlePreset.S} presetSm={TitlePreset.M} color={Color.dark}>
                    <Translate message="title" />
                </Title>
                <Paragraph>
                    <Text preset={Preset.S} presetSm={Preset.M} color={Color.dark}>
                        <Translate message="paragraph1" html />
                    </Text>
                </Paragraph>
                <MoreButton isShown={!isFullMessageShown}>
                    <Button
                        color={ButtonColor.dark}
                        buttonType={ButtonType.contextual}
                        onClick={handleMoreButtonClick}
                    >
                        <Translate message="more" />
                    </Button>
                </MoreButton>
                <MoreContent isShown={isFullMessageShown}>
                    <Paragraph>
                        <Text preset={Preset.S} presetSm={Preset.M} color={Color.dark}>
                            <Translate message="paragraph" html />
                        </Text>
                    </Paragraph>
                    <ButtonContainer>
                        <Button
                            color={ButtonColor.dark}
                            buttonType={ButtonType.contextual}
                            link
                            href="/help"
                        >
                            <Translate message="faq" />
                        </Button>
                    </ButtonContainer>
                    <ButtonContainer>
                        <Button
                            color={ButtonColor.dark}
                            buttonType={ButtonType.contextual}
                            link
                            href="/myaccount/newsletter"
                        >
                            <Translate message="newsletter" />
                        </Button>
                    </ButtonContainer>
                </MoreContent>
            </Container>
        </Background>
    );
};
